import React from "react";

import PropTypes from "prop-types";

function CustomLink({ href, children }) {
    return (
        <a href={href} target="_blank" rel="noreferrer">
            {children}
        </a>
    );
}

CustomLink.propTypes = {
    href: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

function CustomH1({ children }) {
    return <span className="title--h1">{children}</span>;
}

CustomH1.propTypes = {
    children: PropTypes.node.isRequired,
};

function CustomH2({ children }) {
    return <span className="title--h2">{children}</span>;
}

CustomH2.propTypes = {
    children: PropTypes.node.isRequired,
};

function CustomH3({ children }) {
    return <span className="title--h3">{children}</span>;
}

CustomH3.propTypes = {
    children: PropTypes.node.isRequired,
};

function CustomDel({ children }) {
    return <del>{children}</del>;
}

CustomDel.propTypes = {
    children: PropTypes.node.isRequired,
};

function CustomP({ children }) {
    return <p>{children}</p>;
}

CustomP.propTypes = {
    children: PropTypes.node.isRequired,
};

function CustomBlockQuote({ children }) {
    return <blockquote>{children}</blockquote>;
}

CustomBlockQuote.propTypes = {
    children: PropTypes.node.isRequired,
};
function useMarkdownComponents() {
    return {
        CustomLink,
        CustomH1,
        CustomH2,
        CustomH3,
        CustomDel,
        CustomP,
        CustomBlockQuote,
    };
}

export default useMarkdownComponents;
